import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ProgressChartCard } from '@mews/b2b-ui';
import { useGetQuota } from '../../../queries/CentralProductsTable';

interface Props {
    enterpriseId: string;
}

export const ProductsQuotaProgressChart = ({ enterpriseId }: Props) => {
    const localizeText = useLocalizeText();

    const { data } = useGetQuota();
    const { count, quota } = data || { count: 0, quota: 2500 };

    const value = (count / quota) * 100;

    // Do not show the chart if the value is less than 90%
    if (value < 90) {
        return null;
    }

    return (
        <ProgressChartCard
            charts={[
                {
                    id: enterpriseId,
                    score: { value: <span>{`${count}/${quota}`}</span> },
                    data: [
                        {
                            id: enterpriseId,
                            name: lt('CentralProductsPerEnterprise'),
                            value,
                        },
                    ],
                    showTitle: false,
                },
            ]}
            id={enterpriseId}
            title={localizeText({ textKey: TextKey.CentralProductsPerEnterprise })}
        />
    );
};
